// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/components/score.scss
// module id = 882
// module chunks = 0